export default "__VITE_ASSET__8b86ef22__"